import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/FormControl/form-control';
import { css } from '@patternfly/react-styles';
import { capitalize, ValidatedOptions } from '../../helpers';
export var TextAreResizeOrientation;

(function (TextAreResizeOrientation) {
  TextAreResizeOrientation["horizontal"] = "horizontal";
  TextAreResizeOrientation["vertical"] = "vertical";
  TextAreResizeOrientation["both"] = "both";
})(TextAreResizeOrientation || (TextAreResizeOrientation = {}));

export var TextArea =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextArea, _React$Component);

  function TextArea(props) {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextArea).call(this, props));

    _this.handleChange = function (event) {
      if (_this.props.onChange) {
        _this.props.onChange(event.currentTarget.value, event);
      }
    };

    if (!props.id && !props['aria-label']) {
      // eslint-disable-next-line no-console
      console.error('TextArea: TextArea requires either an id or aria-label to be specified');
    }

    return _this;
  }

  _createClass(TextArea, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          value = _a.value,
          onChange = _a.onChange,
          validated = _a.validated,
          isRequired = _a.isRequired,
          resizeOrientation = _a.resizeOrientation,
          props = __rest(_a, ["className", "value", "onChange", "validated", "isRequired", "resizeOrientation"]);

      var orientation = "resize".concat(capitalize(resizeOrientation));
      return React.createElement("textarea", Object.assign({
        className: css(styles.formControl, className, resizeOrientation !== TextAreResizeOrientation.both && styles.modifiers[orientation], validated === ValidatedOptions.success && styles.modifiers.success),
        onChange: this.handleChange
      }, typeof this.props.defaultValue !== 'string' && {
        value: value
      }, {
        "aria-invalid": validated === ValidatedOptions.error,
        required: isRequired
      }, props));
    }
  }]);

  return TextArea;
}(React.Component);
TextArea.defaultProps = {
  className: '',
  isRequired: false,
  validated: 'default',
  resizeOrientation: 'both',
  'aria-label': null
};